
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/recruiter/[slug]",
      function () {
        return require("private-next-pages/recruiter/[slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/recruiter/[slug]"])
      });
    }
  